import { render } from "./PerformanceDetail.vue?vue&type=template&id=60a3441b&scoped=true"
import script from "./PerformanceDetail.vue?vue&type=script&lang=js"
export * from "./PerformanceDetail.vue?vue&type=script&lang=js"

import "./PerformanceDetail.vue?vue&type=style&index=0&id=60a3441b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a3441b"]])

export default __exports__